export default "__VITE_ASSET__17e3a0b2__"